import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import DividendTable from "../../../Components/ReportTables/DividendTable";
import Loader from "../../../Components/Common/Loader";
import { Col, Row, Toast } from "react-bootstrap";
import warningIcon from "../../../asset/images/icons/warning.svg";
import errorImage from "../../../asset/images/icons/errorImage.svg";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
// import { toast, ToastContainer } from "react-toastify";

function DividendReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("grid");
  const [data, setData] = useState();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [error, setError] = useState("");
  const [seg, setSeg] = useState("stocks");
  const [serverError, setServerError] = useState("");
  const [customShow, setCustomShow] = useState(false)
  const ClientId2 = localStorage.getItem("ClientId2");


  if (fromDate == "" || toDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    let lastVal = new Date();
    lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(firstDay)
    setToDate(lastDay)

  }
  let clientCode = "";

  const getDividendReport = async (clientCode) => {
    setLoader(true);

    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "mail") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: seg,
      isin: "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.DividendReport_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);

      const res = response.data;

      if (res) {
        if (fileType == "grid") {
          setData(res?.divList);
        } else if (fileType == "excel") {
          window.open(res, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        if (fileType == "excel") {
          toast.error("Dividend Report does not exist");
        } else if (fileType == "pdf") {
          toast.error("Dividend Report does not exist");
        } else if (fileType == "mail") {
          toast.error("Dividend Report does not exist");
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderMail(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "mail") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setData("");
    setFileType("");
    setSeg(e.target.value);
  };

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setData("");
    setError("");
    setFileType("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setData("");
    setError("");
    setFileType("");
    setServerError("");
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (fileType != "") {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setCheckDate(false);
          getDividendReport(clientCode);
        } else {
          setCheckDate(true);
        }
      }
    }
    // setFileType("");
  }, [fileType]);

  const handleOnClick = (e) => {
    setFileType("")
    if (fromDate.length > 0 && toDate.length > 0 && seg.length > 0) {
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setFileType(e.target.value);
          setError("");
        } else {
          setCheckDate(true);
          setFileType("");
          setError("Please Select Correct Date");
        }
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");
  const onChangeDuration = () => {
    setData("");
    setError("");
    setFileType("");
    setServerError("");
  }
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="dividend-report"
        role="tabpanel"
        aria-labelledby="dividend-report"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    onChangeDuration={onChangeDuration}
                    screen="Client Dashboard"
                    className="report-custom-select"
                  />
                </div>
                {/* <div className="d-flex"> */}
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
                {/* </div> */}
                {/* <div className="d-flex align-items-center"> */}
                <div className="form-group">
                  <label className="form-label">Segment: </label>
                  <select
                    className="report-custom-select"
                    onChange={handleSegmentChange}
                  >
                    <option value="stocks">{Constants.EQ}</option>
                    <option value="mf">{Constants.MF}</option>
                    <option value="fo">{Constants.FandO}</option>
                  </select>
                </div>

                {/* </div> */}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-pdfsvg"></span> */}

              {Constants.Submit}
            </button>
          </div>

          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data && data ? (
        <div>
          <DividendTable data={data} seg={seg} />
        </div>
      ) : serverError === "Something went wrong, Please try again later." ? (
        <h4 className="report-table-wrapper">{serverError}</h4>
      ) : (
        ""
      )}
    </>
  );
}
export default DividendReportNew;
